<template>
  <div class="" style="margin-top: 10px">
    <SelectButton
      style="padding: 10px"
      v-model="currentMannschaft"
      :options="mannschaften"
      @change="currentMannschaftChanged"
      optionLabel="name"
    />
    <div
      class="flex align-items-center justify-content-center"
      v-if="currentMannschaft && currentMannschaft.id"
    >
      <MegaMenu
        :model="teamAdminMenuItems"
        breakpoint="395px"
        style="margin-top: 10px; min-width: 200px; display: flex; justify-content: center"
      >
        <template #item="{ item }">
          <a
            class="p-menuitem-link"
            @click="onItemClick(item)"
            :style="
              'display: flex; flex-direction: column; padding: 5px 6px;border: solid' +
              (item.active ? ';color: #2196f3' : '#dee2e6') +
              ';border-width: 0 0 3px 0;' +
              (item.active ? ';color: #2196f3' : '')
            "
          >
            <span v-if="item.icon" :class="item.icon" style="font-size: 34px"></span>
            <img v-else-if="item.img" :src="item.img" style="height: 34px; width: auto" />
            <span
              class="p-menuitem-text"
              :style="
                'margin-top: 8px; font-size: 12px; font-weight: 600;' +
                (item.active ? ';color: #2196f3' : '')
              "
              >{{ item.label }}</span
            >
          </a>
        </template>
      </MegaMenu>
    </div>
    <div
      v-if="
        activeMenuItem &&
        activeMenuItem.name == 'spieltage' &&
        currentMannschaft &&
        currentMannschaft.id
      "
    >
      <team-game-day-view
        v-model:mannschaft="currentMannschaft"
        v-model:gameDayViewIndex="gameDayViewIndex"
        @gameDayViewIndexChanged="gameDayViewIndexChanged"
      />
    </div>
    <div v-if="activeMenuItem && activeMenuItem.name == 'mannschaft'">
      <div
        class="flex flex-wrap card-container align-items-center justify-content-center"
        style="margin-top: 10px"
      >
        <Dialog v-model:visible="showSignOffDialog" :closable="false">
          <template #header>
            <h3>Spieler abmelden</h3>
          </template>

          Soll der Spieler {{ signOffPlayer.name }} wirklich abgemeldet werden?

          <template #footer>
            <Button
              label="Abmelden"
              icon="pi pi-check"
              class="p-button-text"
              @click="executeSignOff"
            />
            <Button label="Abbrechen" icon="pi pi-times" @click="cancelEdit" />
          </template>
        </Dialog>
        <div style="max-width: 1000px; width: 100%">
          <DataTable
            class="p-datatable-sm"
            :value="currentMannschaft.players"
            stripedRows
            responsiveLayout="stack"
            breakpoint="550px"
            style="margin-top: 10px"
          >
            <Column field="bwdvNumber" header="BWDV-Nr."></Column>
            <Column field="name" header="Name">
              <template #body="{ data, field }">
                <InputText
                  v-if="editPlayer && data.id == editPlayer.id"
                  v-model="data[field]"
                  autofocus
                />
                <span v-else>{{ data[field] }}</span>
              </template></Column
            >
            <Column field="eligibleToPlaySince" header="Spielberechtigt seit/ab">
              <template #body="{ data, field }">
                <span v-if="data[field] && data[field].length > 0">
                  {{ data[field] }}</span
                >
                <span v-else>Keine Einschränkungen</span>
              </template>
            </Column>
            <Column field="eligibleToPlayTill" header="Spielberechtigt bis">
              <template #body="{ data, field }">
                <span v-if="data[field] && data[field].length > 0">
                  {{ data[field] }}</span
                >
                <span v-else>Keine Einschränkungen</span>
              </template>
            </Column>
            <Column header="Aktionen">
              <template #body="slotProps">
                <!--
                <Button
                  v-if="!editPlayer"
                  style="margin: 2px 2px"
                  icon="pi pi-pencil"
                  v-tooltip.top="'Editieren'"
                  class="p-button-rounded p-button-success mb2"
                  @click="edit(slotProps.data)"
                />-->
                <Button
                  v-if="!editPlayer"
                  style="margin: 2px 2px"
                  icon="pi pi-trash"
                  v-tooltip.top="'Abmelden'"
                  class="p-button-rounded p-button-warning"
                  @click="signOff(slotProps.data)"
                />
                <Button
                  v-if="editPlayer && slotProps.data.id == editPlayer.id"
                  style="margin: 2px 2px"
                  icon="pi pi-save"
                  v-tooltip.top="'Speichern'"
                  class="p-button-rounded p-button-success mb2"
                  @click="save()"
                />
                <Button
                  v-if="editPlayer && slotProps.data.id == editPlayer.id"
                  style="margin: 2px 2px"
                  icon="pi pi-times"
                  v-tooltip.top="'Abbrechen'"
                  class="p-button-rounded p-button-warning mb2"
                  @click="cancelEdit()"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <div v-if="activeMenuItem && activeMenuItem.name == 'pokal'">
      <TeamAdminCupView :currentTeamId="currentMannschaft.id" />
    </div>
    <div v-if="activeMenuItem && activeMenuItem.name == 'spielort'">
      <div
        class="flex align-items-center justify-content-center"
        v-if="currentMannschaft"
      >
        <Message severity="info" :closable="true"
          >Hinweis: Die Anschrift des Spielortes (Straße, PLZ und Ort) kann aktuell nur
          der Spielleiter ändern! Bei Änderungen oder Spielortwechsel diesen bitte
          informieren.</Message
        >
      </div>
      <RecordView
        ref="spielortRecordView"
        recordType="location"
        :recordId="currentMannschaft.location.id"
        :showLinks="false"
        :disabledFields="['street', 'plz', 'city']"
      />
    </div>
    <div v-if="activeMenuItem && activeMenuItem.name == 'contactperson'">
      <RecordView
        ref="contactpersonRecordView"
        recordType="contactperson"
        :recordId="currentMannschaft.primaryContact.id"
        :showLinks="false"
      />
    </div>
    <div v-if="activeMenuItem && activeMenuItem.name == '2ksettings'">
      <div
        class="flex flex-wrap card-container align-items-center justify-content-center"
        style="margin-top: 20px"
      >
        <div class="card threek-settings-card">
          <div class="field grid" style="align-items: baseline">
            <label for="2KClientId" class="col-fixed" style="width: 170px"
              >3K-Mandanten-Key</label
            ><InputNumber
              id="2KClientId"
              v-model="twoKSettings.clientId"
              inputId="withoutgrouping"
              :useGrouping="false"
            />
          </div>
          <Button
            label="Einstellungen übernehmen"
            class="mt-2"
            @click="change2KSettings()"
          />
          <Dialog v-model:visible="display2KSettingsDialog" :closable="false">
            <template #header>
              <h3>3K Einstellungen ändern</h3>
            </template>
            <div v-if="!twoKSettings.error || twoKSettings.error.length < 1">
              <h4 style="color: green">Die 3K-Einstellungen sind gültig!</h4>
              <h4>Verein in 3K: {{ twoKSettings.clientName }}</h4>
              <h4>Mandanten-ID: {{ twoKSettings.clientId }}</h4>
              <h4 v-if="twoKSettings.backendId">
                Backend-ID: {{ twoKSettings.backendId }}
              </h4>
              <span v-else>
                In 3K gibt es für den Verein noch kein Spiel. Das Backend wird
                ermittelt, sobald das erste Spiel in 3K angelegt ist.
              </span>
            </div>
            <div v-else>
              <h4 style="color: red">Die 3K-Einstellungen wurden nicht übernommen</h4>
              <span> {{ twoKSettings.error }}</span>
            </div>
            <template #footer>
              <Button
                label="Schließen"
                class="p-button-text"
                @click="display2KSettingsDialog = false"
              />
            </template>
          </Dialog>
          <div class="opponent-player-export">
            <div class="opponent-player-export-hint">
              Spielerliste aller Mannschaften, die in dieser Saison bei Ihnen zu
              Gast sind, als CSV zum Import in 3K. Der Pokal bleibt außen vor.
            </div>
            <Message severity="warn" :closable="false" style="text-align: left">
              3K übernimmt den Mannschaftsnamen nur als Freitext. Die Zuordnung
              zu einer Mannschaft kann der Import nicht setzen, die muss in 3K
              von Hand nachgezogen werden.
            </Message>
            <div class="opponent-row">
              <span class="opponent-gameday text-color-secondary">
                alle Heimspiele
              </span>
              <span class="opponent-name">Alle Gegner</span>
              <Button
                icon="pi pi-download"
                class="p-button-sm p-button-outlined"
                :loading="opponentPlayerExportRunning"
                :disabled="!currentMannschaft || !currentMannschaft.id"
                @click="downloadOpponentPlayers()"
              />
            </div>
          </div>
          <div class="opponent-player-single">
            <div class="opponent-player-export-hint">
              Oder einzeln, in der Reihenfolge Ihrer Heimspiele:
            </div>
            <Message
              v-if="opponentsLoaded && opponents.length < 1"
              severity="info"
              :closable="false"
            >
              Für diese Mannschaft ist kein Heimspiel angesetzt.
            </Message>
            <div
              v-for="opponent in opponents"
              :key="opponent.teamId"
              class="opponent-row"
            >
              <span class="opponent-gameday text-color-secondary">
                {{ opponent.gameDayNumber }}. Spieltag
                <template v-if="opponent.date"> · {{ opponent.date }}</template>
              </span>
              <span class="opponent-name">{{ opponent.name }}</span>
              <Button
                icon="pi pi-download"
                class="p-button-sm p-button-outlined"
                :loading="opponentExportRunning === opponent.teamId"
                @click="downloadOpponentPlayers(opponent)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import twoKLogo from "../../assets/3k-logo.svg";
import { useMenuService } from "../../services/MenuService/UseMenuService";
import ServerConnection from "../../services/ServerConnection/ServerConnection";
import FailureHandler from "../../services/ServerConnection/FailureHandler";
import TeamGameDayView from "./TeamGameDayView";
import SelectButton from "primevue/selectbutton";
import MegaMenu from "primevue/megamenu";
import RecordView from "../records/RecordView.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Dialog from "primevue/dialog";
import Message from "primevue/message";
import { useWizardService } from "../../services/WizardService/UseWizardService";
import TeamAdminCupView from "./TeamAdminCupView";
import { setActiveMenuItemByName } from "../../services/MenuService/MenuItemStateUtils";
const gameDaysMenuItem = {
  index: 0,
  name: "spieltage",
  label: "Spieltage",
  icon: "pi pi-fw pi-calendar",
  style: "padding: 0px 1px",
  active: false,
  items: [],
};
const teamMenuItem = {
  index: 1,
  name: "mannschaft",
  label: "Mannschaft",
  icon: "pi pi-fw pi-users",
  style: "padding: 0px 1px",
  active: false,
  items: [],
};
const cupMenuItem = {
  index: 2,
  name: "pokal",
  label: "Pokal",
  icon: "pi pi-fw pi-sitemap",
  style: "padding: 0px 1px",
  active: false,
  items: [],
};
const contactPersonMenuItem = {
  label: "Vertretung",
  index: 0,
  name: "contactperson",
  icon: "pi pi-fw pi-user",
  style: "padding: 0px 1px",
  active: false,
};
const locationMenuItem = {
  index: 1,
  name: "spielort",
  label: "Spielort",
  icon: "pi pi-fw pi-compass",
  style: "padding: 0px 1px",
  active: false,
};
const twoKMenuItem = {
  index: 2,
  name: "2ksettings",
  label: "3K-Einstellungen",
  img: twoKLogo,
  style: "padding: 0px 1px",
  active: false,
};
const etcMenuItem = {
  index: 4,
  name: "weiteres",
  label: "Weiteres",
  icon: "pi pi-fw pi-ellipsis-v",
  style: "padding: 0px 1px",
  active: false,
  items: [
    [
      {
        items: [contactPersonMenuItem, locationMenuItem, twoKMenuItem],
      },
    ],
  ],
};
const cloneMenuItem = (menuItem) => JSON.parse(JSON.stringify(menuItem));
export default {
  name: "TeamAdminDashBoard",
  components: {
    SelectButton,
    MegaMenu,
    RecordView,
    DataTable,
    Column,
    Button,
    InputText,
    InputNumber,
    Dialog,
    Message,
    TeamGameDayView,
    TeamAdminCupView,
  },
  computed: {
    loggedIn() {
      var user = localStorage.getItem("user");
      return user && user != null;
    },
    showSignOffDialog() {
      return this.signOffPlayer && this.signOffPlayer != null;
    },
    teamAdminMenuItems() {
      var menuItems = [cloneMenuItem(gameDaysMenuItem), cloneMenuItem(teamMenuItem)];

      if (this.currentTeamPlaysCup()) {
        menuItems.push(cloneMenuItem(cupMenuItem));
      }
      menuItems.push(cloneMenuItem(etcMenuItem));

      var activeMenuItemName;
      if (this.activeMenuItem) {
        activeMenuItemName = this.activeMenuItem.name;
      } else {
        activeMenuItemName = localStorage.getItem("activeMenuItemName");
      }
      this.handleMenuItemAktiveByName(activeMenuItemName, menuItems);
      return menuItems;
    },
  },
  data() {
    return {
      menuService: useMenuService(),
      wizardService: useWizardService(),
      mannschaften: null,
      currentMannschaft: null,
      gameDayViewIndex: -1,

      activeMenuItem: null,
      editPlayer: null,
      signOffPlayer: null,
      display2KSettingsDialog: false,
      twoKSettings: null,
      opponentPlayerExportRunning: false,
      opponentExportRunning: null,
      opponents: [],
      opponentsLoaded: false,
    };
  },
  props: {
  },
  created() {
    var currentGameIndex = localStorage.getItem("currentGameDayIndex");
    if (currentGameIndex) {
      this.gameDayViewIndex = currentGameIndex;
    }
    this.ensureActiveMenuItem();
    this.updateMainMenu();
    this.loadMannschaften();
  },
  watch: {
    loggedIn: {
      immediate: true,
      handler(isLoggedIn) {
        if (!isLoggedIn) {
          this.$router.push("/login");
        }
      },
    },
    currentMannschaft(newTeam, oldTeam) {
      if (newTeam && newTeam.id && (!oldTeam || oldTeam.id !== newTeam.id)) {
        this.loadTeamData();
      }
      this.ensureActiveMenuItem();
      this.updateMainMenu();
    },
    activeMenuItem() {
      this.ensureActiveMenuItem();
      this.updateMainMenu();
    },
  },
  methods: {
    ensureActiveMenuItem() {
      if (
        !this.activeMenuItem ||
        (this.activeMenuItem.name == "pokal" && !this.currentTeamPlaysCup())
      ) {
        this.activeMenuItem = { name: "spieltage" };
      }
    },
    edit(data) {
      this.editPlayer = data;
      this.signOffPlayer = null;
    },
    cancelEdit() {
      this.editPlayer = null;
      this.signOffPlayer = null;
    },
    signOff(data) {
      this.editPlayer = null;
      this.signOffPlayer = data;
    },
    executeSignOff() {
      if (this.signOffPlayer) {
        ServerConnection.put("teamadmin/player/signOff?playerId=" + this.signOffPlayer.id)
          .then(() => {
            this.signOffPlayer = null;
            this.mannschaften = null;
            this.loadMannschaften();
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    save() {
      if (this.editPlayer) {
        ServerConnection.put("teamadmin/player/", JSON.stringify(this.editPlayer))
          .then((response) => {
            if (response.status != 200) {
              return Promise.reject(response);
            }
          })
          .then(() => {
            this.editPlayer = null;
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    loadMannschaften() {
      if (!this.mannschaften || this.mannschaften == null) {
        ServerConnection.get("teamadmin/mannschaften")
          .then((response) => response.data)
          .then((data) => {
            this.mannschaften = data;
            if (this.mannschaften.length == 1) {
              this.currentMannschaft = this.mannschaften[0];
            } else {
              var teamId = localStorage.getItem("currentMannschaftId");

              if (teamId) {
                var currentTeam = this.mannschaften.find((team) => team.id == teamId);
                if (currentTeam) {
                  this.currentMannschaft = currentTeam;
                }
              }
            }
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    loadTeamData() {
      if (this.currentMannschaft && this.currentMannschaft.id) {
        ServerConnection.get("twoK/settings?teamId=" + this.currentMannschaft.id)
          .then((resp) => {
            this.twoKSettings = resp.data;
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
        this.loadOpponents();
      }
    },
    loadOpponents() {
      this.opponents = [];
      this.opponentsLoaded = false;
      ServerConnection.get(
        "twoK/opponents?teamId=" + this.currentMannschaft.id
      )
        .then((resp) => {
          this.opponents = resp.data;
          this.opponentsLoaded = true;
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    updateMainMenu() {
      if (
        this.currentMannschaft &&
        this.activeMenuItem &&
        this.activeMenuItem.name == "spielort"
      ) {
        if (this.$refs.spielortRecordView.editMode) {
          this.menuService.setMainMenuItemNames([
            {
              name: "save",
              command: () => {
                this.$refs.spielortRecordView.saveRecord();
                this.$refs.spielortRecordView.switchEditMode(false);
                this.updateMainMenu();
              },
            },
            {
              name: "cancel",
              command: () => {
                this.$refs.spielortRecordView.reloadRecord();
                this.updateMainMenu();
              },
            },
          ]);
        } else {
          this.menuService.setMainMenuItemNames([
            "messages",
            "settings",
            "help",
            "sidebar",
            "logout",
            {
              name: "edit",
              command: () => {
                this.$refs.spielortRecordView.switchEditMode(true);
                this.updateMainMenu();
              },
            },
          ]);
        }
      } else if (
        this.currentMannschaft &&
        this.activeMenuItem &&
        this.activeMenuItem.name == "contactperson"
      ) {
        if (this.$refs.contactpersonRecordView.editMode) {
          this.menuService.setMainMenuItemNames([
            {
              name: "save",
              command: () => {
                this.$refs.contactpersonRecordView.saveRecord();
                this.$refs.contactpersonRecordView.switchEditMode(false);
                this.updateMainMenu();
              },
            },
            {
              name: "cancel",
              command: () => {
                this.$refs.contactpersonRecordView.reloadRecord();
                this.updateMainMenu();
              },
            },
          ]);
        } else {
          this.menuService.setMainMenuItemNames([
            "messages",
            "settings",
            "help",
            "sidebar",
            "logout",
            {
              name: "edit",
              command: () => {
                this.$refs.contactpersonRecordView.switchEditMode(true);
                this.updateMainMenu();
              },
            },
          ]);
        }
      } else {
        this.menuService.setMainMenuItemNames(["messages", "settings", "sidebar", "help", "logout"]);
      }

      if (this.currentMannschaft) {
        this.menuService.setSidebarItems([
          {
            label: "Spieler zur Mannschaft hinzufügen",
            icon: "pi pi-link",
            command: () => {
              this.wizardService.navigateToWizard(
                this.$router,
                "addPlayer",
                {
                  baseRecord: this.currentMannschaft,
                },
                this.$route.fullPath
              );
            },
          },
        ]);
      } else {
        this.menuService.setSidebarItems([]);
      }
    },
    onItemClick(item) {
      this.activeMenuItem = { name: item.name };
      localStorage.setItem("activeMenuItemName", item.name);
    },
    handleMenuItemAktiveByName(name, items) {
      return setActiveMenuItemByName(name, items);
    },
    currentMannschaftChanged() {
      if (this.currentMannschaft) {
        localStorage.setItem("currentMannschaftId", this.currentMannschaft.id);
      }
    },
    change2KSettings() {
      if (this.currentMannschaft && this.currentMannschaft.id) {
        ServerConnection.put(
          "twoK/settings?teamId=" + this.currentMannschaft.id,
          this.twoKSettings
        )
          .then((resp) => {
            this.twoKSettings = resp.data;
            this.display2KSettingsDialog = true;
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    downloadOpponentPlayers(opponent) {
      if (!this.currentMannschaft || !this.currentMannschaft.id) {
        return;
      }
      var url = "twoK/opponentPlayers?teamId=" + this.currentMannschaft.id;
      if (opponent) {
        url += "&opponentTeamId=" + opponent.teamId;
        this.opponentExportRunning = opponent.teamId;
      } else {
        this.opponentPlayerExportRunning = true;
      }
      var done = () => {
        this.opponentPlayerExportRunning = false;
        this.opponentExportRunning = null;
      };
      ServerConnection.get(url, { responseType: "blob" })
        .then((response) => {
          done();
          this.saveResponseAsFile(response, "3K-Gegner.csv");
        })
        .catch((error) => {
          done();
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    saveResponseAsFile(response, fallbackFileName) {
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var link = document.createElement("a");
      link.href = url;
      link.download = this.fileNameOfResponse(response, fallbackFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    fileNameOfResponse(response, fallbackFileName) {
      var disposition = response.headers
        ? response.headers["content-disposition"]
        : null;
      if (!disposition) {
        return fallbackFileName;
      }
      var match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
      return match ? decodeURIComponent(match[1]) : fallbackFileName;
    },
    gameDayViewIndexChanged(gameDayViewIndex) {
      this.gameDayViewIndex = gameDayViewIndex;
    },
    currentTeamPlaysCup() {
      return this.currentMannschaft && this.currentMannschaft.registeredForCup;
    },
  },
};
</script>

<style lang="css">
.opponent-player-export {
  margin-top: 25px;
  padding-top: 15px;
  border-top: 1px solid #ced4da;
}
.threek-settings-card {
  width: 660px;
  max-width: 100%;
}
.opponent-player-single {
  margin-top: 18px;
}
.opponent-player-export-hint {
  margin-bottom: 10px;
}
.opponent-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
}
.opponent-gameday {
  flex: 0 0 190px;
  font-size: 12px;
}
.opponent-name {
  flex: 1 1 auto;
  text-align: left;
  font-weight: 600;
}
.p-buttonset .p-button:not(:last-child) {
  border: 1px solid #ced4da;
}
@media screen and (max-width: 500px) {
  /* Darken the line between the entries in mobile mode */
  .p-datatable .p-datatable-tbody > tr > td {
    text-align: right !important;
    border: 1px solid #555;
    border-width: 0 0 2px 0;
  }
  /* Enlarge distance between each entry in mobile mode */
  .p-datatable .p-datatable-tbody > tr > td:is(:last-child) {
    margin-bottom: 0.7rem;
    padding-bottom: 1rem;
  }
}
.p-message .p-message-wrapper {
  padding: 0.5rem 1rem !important;
}
.p-overlay-badge .p-badge {
  transform: translate(20%, -20%) !important;
}
</style>
